// Turbo Color Map
// https://research.google/blog/turbo-an-improved-rainbow-colormap-for-visualization/
// const color = interpolateTurbo(0.5); // A mid-point color

function interpolateTurbo(t) {
  const turboTable = [
    [0.19, 0.07, 0.23],
    [0.23, 0.20, 0.49],
    [0.27, 0.45, 0.74],
    [0.30, 0.68, 0.85],
    [0.34, 0.87, 0.72],
    [0.48, 1.00, 0.51],
    [0.74, 1.00, 0.28],
    [1.00, 0.83, 0.04],
    [0.93, 0.48, 0.02],
    [0.71, 0.16, 0.01]
  ];
  const n = turboTable.length - 1;
  const i = Math.min(Math.max(0, Math.floor(t * n)), n - 1);
  const f = t * n - i;
  const [r1, g1, b1] = turboTable[i];
  const [r2, g2, b2] = turboTable[i + 1];
  const r = r1 + f * (r2 - r1);
  const g = g1 + f * (g2 - g1);
  const b = b1 + f * (b2 - b1);
  return `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`;
}

// Turbo for fahrenheit temperature values 32 -180
function fahrenheitToTurbo(t) {
  const range = [32, 180];
  const value = range[0] + t * (range[1] - range[0]);
  return interpolateTurbo((value - range[0]) / (range[1] - range[0]));
}

// Red white blue color map for relative values
// Use: interpolateRdBu(0.5) // Returns a mid-point color (white)

function interpolateRdBu(t) {
  const r = t < 0.5 ? 255 : Math.round(255 * (1 - 2 * (t - 0.5)));
  const g = Math.round(255 * (1 - Math.abs(2 * t - 1)));
  const b = t > 0.5 ? 255 : Math.round(255 * (2 * t));
  return `rgb(${r}, ${g}, ${b})`;
}


// ---------------------------------------------------------------------------
// Helper – map deviation value → colour
//  • Positive  → red   (deeper red as the magnitude grows)
//  • Negative  → blue  (deeper blue as the magnitude grows)
//  • Near‑zero → white
// The scaling constants below keep it simple; adjust to taste.
// ---------------------------------------------------------------------------
function getDeviationColor(val) {
  if (val == null || isNaN(val)) {
    return 'rgb(255,255,255)';
  }
  const max   = 5;
  const clamp = (n, lo, hi) => Math.min(Math.max(n, lo), hi);
  if (Math.abs(val) < 0.1) {
    // White center
    return 'rgb(255,255,255)';
  }
  if (val > 0) {
    const t = clamp(val / max, 0, 1);
    const r = 255;
    const g = Math.floor(255 * (1 - t));
    const b = Math.floor(255 * (1 - t));
    return `rgb(${r},${g},${b})`;
  } else {
    const t = clamp(-val / max, 0, 1);
    const r = Math.floor(255 * (1 - t));
    const g = Math.floor(255 * (1 - t));
    const b = 255;
    return `rgb(${r},${g},${b})`;
  }
}

module.exports = {
  interpolateTurbo,
  fahrenheitToTurbo,
  interpolateRdBu,
  getDeviationColor 
};
